import { Profile } from '@/types'
import { TypeGuards } from '@codeleap/types'

const verify = (v) => !TypeGuards.isNil(v)

export function checkSignupCompletion(data: Profile) {
  // const firebase = await getFirebase()

  const signupInfo = [
    data?.first_name,
    data?.last_name,
    data?.email,
  ]

  const hasCompletedSignup = signupInfo.every(verify)

  const personalInfo = [
    data?.birthday,
    data?.gender,
    data?.country,
  ]

  const hasCompletedPersonalInfo = personalInfo.every(verify)

  const orgInfo = [
    data?.seniority,
    data?.organization?.id,
    data?.department,
  ]

  const hasCompletedOrganizationInfo = orgInfo.every(verify)

  logger.debug('Signup completion', { signupInfo, personalInfo, orgInfo }, 'Auth')

  const steps = [
    ['signup', hasCompletedSignup],
    ['aboutYou', hasCompletedPersonalInfo],
    ['aboutJob', hasCompletedOrganizationInfo],
  ] as const

  const nextStep = steps.find(x => !x?.[1])?.[0]

  const isComplete = steps.every(x => x?.[1])

  // if (isComplete && !(await isEmailVerified(data))) {
  //   return {
  //     isComplete: false,
  //     nextStep: 'VerifyEmail',
  //     modal: 'verifyEmailBefore',
  //   }
  // }

  return {
    isComplete,
    nextStep,
  }
}
